<div *ngIf="!availableSubdomains.length" class="place-self-center">
  <mat-spinner [diameter]="32"></mat-spinner>
</div>

<div
  *ngIf="availableSubdomains.length"
  [ngClass]="(isMobile$ | async) ? 'justify-center text-center' : 'grid-cols-[1.3fr_1fr] gap-16 items-center'"
  class="grid items-center">
  <div>
    <h2 class="m-0 mb-4">Here is your shiny new subdomain 🤩</h2>
    <p class="m-0 mb-6">You'll be able to add or purchase your own domain later.</p>

    <form [formGroup]="form">
      <div class="flex flex-col lg:flex-row gap-3 mb-1">
        <mat-form-field class="nopadding">
          <input matInput type="text" formControlName="subdomain" autofocus placeholder="apple" />
        </mat-form-field>

        <mat-form-field class="nopadding">
          <mat-select formControlName="domain">
            <mat-option *ngFor="let sub of availableSubdomains" [value]="sub">.{{ sub }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <mat-error *ngIf="form.controls.subdomain.getError('required')">Subdomain is required</mat-error>
      <mat-error *ngIf="form.controls.subdomain.getError('custom')">
        {{ form.controls.subdomain.getError('custom') }}
      </mat-error>
    </form>

    <sbnb-button
      class="block mt-5"
      [ngClass]="(isMobile$ | async) ? 'justify-self-center' : 'justify-self-start'"
      [loading]="loading"
      [disabled]="form.invalid"
      (clicked)="checkDomainAvailability()">
      Continue
    </sbnb-button>
  </div>

  <div *ngIf="!(isMobile$ | async)" class="grid place-content-center">
    <img class="max-h-[480px] w-auto max-w-[360px]" src="/assets/images/direct-site-creation/stage1.svg" />
  </div>
</div>
